import {
  type CMSFilterableTileContainerDTO,
  type CMSFilterableTileContainerFilterDTO,
  type CMSFilterableTileContainerTileDTO,
} from "./dto";
import classNames from "classnames";
import { DesktopContainerTypes, MobileContainerTypes } from "../CMSTeaserContainer/CMSTeasers";
import { Card } from "../../../Configurators/Linear/components/Card";
import { CMSMedia } from "../media/CMSMedia";
import { cleanupText } from "../CMSSection";
import { CMSTeaserContainer } from "~/CMSComponents/components/CMSTeaserContainer/CMSTeaserContainer";
import { useTileFilter } from "~/CMSComponents/components/CMSFilterableTileContainer/useTileFilter";
import { useIsMinDesktopSize } from "~/common/hooks/useMediaQuery";

interface Props extends Omit<CMSFilterableTileContainerDTO, "type"> {
  className?: string;
}

export type FilterData = CMSFilterableTileContainerFilterDTO;

export const CMSFilterableTileContainer = ({
  className,
  title,
  showAllLabel,
  filters = [],
  teasers = [],
  scrollType: desktopScrollType = DesktopContainerTypes.DEFAULT,
  itemsPerRow: desktopItemsPerRow = 1,
  mobileScrollType = MobileContainerTypes.DEFAULT,
  mobileItemsPerRow = 1,
}: Props) => {
  const isDesktop = useIsMinDesktopSize();
  const { filterContainer, visibleTiles } = useTileFilter({ filters, showAllLabel, allTiles: teasers });

  return (
    <div className={classNames("scha__cms__filterable-container", className)}>
      {title && (
        <p className="scha__cms__filterable-container__title headline_h3_left headline_h3_left--default">{title}</p>
      )}

      {filterContainer}

      <CMSTeaserContainer
        scrollType={desktopScrollType}
        itemsPerRow={desktopItemsPerRow}
        mobileScrollType={mobileScrollType}
        mobileItemsPerRow={mobileItemsPerRow}
        teasers={visibleTiles}
        renderTeaser={(t) => <DataTile {...t} isDesktop={isDesktop} />}
        renderTeaserDetailsContainer={() => null}
      />
    </div>
  );
};

interface DataTileProps extends Omit<CMSFilterableTileContainerTileDTO, "type" | "tags"> {
  className?: string;
  onClick?: () => void;
  isDesktop: boolean;
}

const DataTile = ({ className, onClick, media, label, isDesktop, url, target }: DataTileProps) => {
  const tag = url ? "a" : "div";
  label = cleanupText(label);

  return (
    <Card
      as={tag}
      disableHover={tag === "div"}
      className={classNames("scha__cms__filterable-container__tile", className)}
      onClick={onClick}
      href={url}
      target={target === "newWindow" ? "_blank" : undefined}
    >
      {media && <CMSMedia {...media} className="scha__cms__filterable-container__tile__media" ratio={"16/9"} />}
      {label && <div className="scha__cms__filterable-container__tile__content copy_left">{label}</div>}
    </Card>
  );
};
